import { get } from 'lodash'

import { types } from './chargeDataLogs.actions'
import { ChargeDataLog } from 'types/ChargeData.types'

type ChargeDataState = {
  logs: {
    items: ChargeDataLog[]
    pagination: {
      total: number
      limit: number
      page: number
      pages: number
    }
  }
  uploadStatus: {
    status: string
    message: string
    errors: string[]
  }
  filters: {
    startDate: string | null
    endDate: string | null
    userEmail: string
    fileName: string
    status: string
  }
  loading: boolean
}

const INITIAL_STATE: ChargeDataState = {
  logs: {
    items: [],
    pagination: {
      total: 0,
      limit: 10,
      page: 0,
      pages: 0
    }
  },
  uploadStatus: {
    status: '',
    message: '',
    errors: []
  },
  filters: {
    startDate: null,
    endDate: null,
    userEmail: '',
    fileName: '',
    status: ''
  },
  loading: false
}

function setState(state: ChargeDataState) {
  return function _handle(payload: Record<string, any>) {
    return { ...state, ...payload }
  }
}

export default function _reducer(state = INITIAL_STATE, { type, payload }) {
  const _handlers = {
    [types.SET_LOGS]: setState(state),
    [types.SET_UPLOAD_STATUS]: payload => ({
      ...state,
      uploadStatus: {
        status: payload.status,
        message: payload.message,
        errors: payload.errors
      }
    }),
    [types.CLEAR_UPLOAD_STATUS]: () => ({
      ...state,
      uploadStatus: INITIAL_STATE.uploadStatus
    }),
    [types.SET_FILTERS]: payload => ({
      ...state,
      filters: { ...state.filters, ...payload.filters }
    }),
    [types.CLEAR_FILTERS]: () => ({
      ...state,
      filters: INITIAL_STATE.filters
    }),
    _default: () => state
  }

  return get(_handlers, type, _handlers._default)(payload)
}
